const updateVisibleProjectTaskModal = {
    namespaced: true,
    state: {
        isShowProjectTaskFormModal: false,
        layout: null,
        isModalVisibleFromHeader: false,
    },
    mutations: {
        UPDATE_VISIBLE_PROJECT_TASK_MODAL(state, data) {
            if(typeof data === "object") {
                state.isShowProjectTaskFormModal = data[0];
                state.layout = data[1];
            } else if(typeof data === "boolean") {
                state.isShowProjectTaskFormModal = data;
                state.layout = null;
            }        
        },
        UPDATE_VISIBLE_PROJECT_TASK_MODAL_FROM_HEADER(state, data) {
            state.isModalVisibleFromHeader = data;
        }

    },
    actions: {
        updateVisibleProjectTaskFormModal: function({ commit }, data) {
            commit("UPDATE_VISIBLE_PROJECT_TASK_MODAL", data);
        },
        updateVisibleProjectTaskFormModalFromHeader: function({ commit }, data) {
            commit("UPDATE_VISIBLE_PROJECT_TASK_MODAL_FROM_HEADER", data);
        }
    }
}

export default updateVisibleProjectTaskModal;